<template>
  <article :class="['format-card', { 'format-card--highlighted': card.highlighted }]">
    <div class="format-card__top">
      <span class="format-card__tile"><component :is="card.icon" /></span>
      <span :class="['format-card__badge', { 'format-card__badge--accent': card.accent }]">{{ badge }}</span>
    </div>
    <h3 class="format-card__title" v-html="getTitleBlock(page, card.group, 'title')"></h3>
    <p class="format-card__text" v-html="getTitleBlock(page, card.group, 'description')"></p>
    <ul class="format-card__points">
      <li v-for="(point, index) in points" :key="index" class="format-card__point">
        <component :is="pointIcon(index)" :size="20" color="#6171E4" />
        <span v-html="point"></span>
      </li>
    </ul>
    <p class="format-card__suits">
      <span v-html="suitsLabel"></span> <span v-html="suits"></span>
    </p>
    <component
      :is="button.component"
      class="format-card__button"
      :route="button.route"
      :hash="button.hash"
    >
      {{ getKeyValueListBlockValue(page, detailsGroup, 'action') }}
    </component>
  </article>
</template>

<script>
import { textBlock } from '@/entities/text-block';
import { RESOURCE_FORMAT_ACTIONS } from '@/features/agent-resources/config';
import { TransparencyFancyButton, VioletFancyButtonWithArrow } from '@/shared/ui/form';
import { CheckLineIcon } from '@/shared/ui/icons';

export default {
  mixins: [ textBlock ],
  props: {
    card: {
      type: Object,
      required: true,
    },
    page: {
      type: String,
      required: true,
    },
  },
  computed: {
    detailsGroup() {
      return `${this.card.group}-details`;
    },
    points() {
      return this.getListBlock(this.page, `${this.card.group}-points`);
    },
    badge() {
      return this.getKeyValueListBlockValue(this.page, this.detailsGroup, 'badge');
    },
    suitsLabel() {
      return this.getKeyValueListBlockValue(this.page, 'formats-details', 'suits-label');
    },
    suits() {
      return this.getKeyValueListBlockValue(this.page, this.detailsGroup, 'suits');
    },
    button() {
      if (this.card.action === RESOURCE_FORMAT_ACTIONS.CONTACTS) {
        return { component: TransparencyFancyButton, route: { name: 'promo' }, hash: '#contacts' };
      }

      return { component: VioletFancyButtonWithArrow, route: { name: 'registration' }, hash: null };
    },
  },
  methods: {
    pointIcon(index) {
      return this.card.pointIcons[index] || CheckLineIcon;
    },
  },
};
</script>

<style lang="scss" scoped>
.format-card {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 40px;
  border-radius: 28px;
  background: #FFFFFF;
  box-shadow: 0 8px 32px rgba(97, 113, 228, 0.08);

  @media (max-width: 800px) {
    padding: 24px;
  }

  &--highlighted {
    background: #EBF2FF;
    box-shadow: none;

    .format-card__point,
    .format-card__badge {
      background: #FFFFFF;
    }
  }

  &__top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
  }

  &__tile {
    flex: none;
    width: 64px;
    height: 64px;
    border-radius: 16px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #FFFFFF;
    box-shadow: 0 8px 32px rgba(97, 113, 228, 0.12);
  }

  &__badge {
    padding: 8px 14px;
    border-radius: 999px;
    background: #EBF2FF;
    color: #4555CC;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 600;
    font-size: 14px;

    &--accent {
      background: #4555CC;
      color: #FFFFFF;
    }
  }

  &__title {
    margin: 0;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 500;
    font-size: 30px;
    line-height: 36px;
  }

  &__text {
    margin: 0;
    font-size: 18px;
    line-height: 25px;
    color: #4E5358;
  }

  &__points {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__point {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 12px 18px;
    border-radius: 16px;
    background: #F9FBFF;
    font-size: 16px;
    line-height: 23px;
  }

  &__suits {
    margin: 0;
    font-size: 15px;
    line-height: 22px;
    color: #494E53;
  }

  &__button {
    width: auto;
    align-self: flex-start;
    margin-top: auto;
  }
}
</style>
